module.exports = "{{ screen_name }}\n"